import { FirmRecord, UserRole } from '@tassat/fred-definitions';
import { UserAccountMapped, WalletRecordExtended } from '@tassat/fred-extended-definitions';

import { FirmWalletUsersAgGrid } from './firmWalletUsersGrid';

export interface FirmWalletUsersGridProps {
    firm: FirmRecord;
    wallet: WalletRecordExtended;
    userAccounts: UserAccountMapped[];
    userRole: UserRole;
}

export default FirmWalletUsersAgGrid;